<template>
  <div class="form-group" :class="{ 'm3p_agentselection-disabled': disabled }">
    <label :class="{ 'm3p_agentselection-checked': value.includes(item.id) }">
      <input
        type="checkbox"
        :id="`${name}.${item.name}`"
        :name="name"
        :value="item.id"
        :disabled="disabled"
        @change="handleChange"
        :checked="value.includes(item.id)"
      />
      {{ item.name }}
    </label>
    <img :src="item.image" width="160" height="39" />
    <h4>{{ item.catch_copy }}</h4>
    <p>{{ item.pr_message_short }}</p>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { useAuctionCompaniesStore } from "@component_path/inquiry_form_common_module/custom_hook/AuctionCompanies";
import { useField } from "vee-validate";
import { watch } from "vue";

const store = useStore();

const props = defineProps({
  name: {
    type: String,
    required: false,
    default: false
  },
  item: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    required: true
  },
  validator: {
    type: Object,
    required: true
  },
  dispatcher: {
    type: String,
    required: true
  }
});

const { agentSelectionAuctionIds } = useAuctionCompaniesStore();

const { value } = useField(props.name, props.validator, {
  validateOnMount: false,
  initialValue: agentSelectionAuctionIds.value || []
});

const handleChange = event => {
  if (event.target.checked) {
    value.value = [
      ...agentSelectionAuctionIds.value,
      Number(event.target.value)
    ];
  } else {
    value.value = [...agentSelectionAuctionIds.value].filter(
      item => item != event.target.value
    );
  }
};
watch(value, () => store.dispatch(props.dispatcher, value.value));
</script>
